import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { CircularProgress } from '@material-ui/core';

const Loading = ({ props }) => {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      data-cy="loading"
      {...props}
    >
      <CircularProgress style={{ color: '#9A9A9A' }} />
    </Box>
  );
};

Loading.propTypes = {
  props: PropTypes.object,
};

export default Loading;
